export default __webpack_public_path__ + "static/media/email.b5e7e17e.png";